// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  Collapse,
  Alert,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import WebsiteGeneratorPage from "./pages/WebsiteGeneratorPage";
import PhotoEditorPage from "./pages/PhotoEditorPage";
import RobotPlayground from "./pages/RobotPlayground";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ChatAssistant from "./components/ChatAssistant";
import AIToolsPage from "./pages/AIToolsPage";
import DropshipToolsPage from "./pages/DropshipToolsPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3F51B5",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#00BCD4",
    },
    info: {
      main: "#FF9800",
    },
    background: {
      default: "#F5F7FA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#2E3A59",
      secondary: "#546E7A",
    },
  },
  typography: {
    fontFamily: ["Poppins", "Montserrat", "Roboto", "sans-serif"].join(","),
    h4: { color: "#3F51B5" },
    h5: { color: "#2E3A59" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          textTransform: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backdropFilter: "blur(8px)",
        },
      },
    },
  },
});

function App() {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {/* Warning banner below the AppBar */}
      <Collapse in={showBanner}>
        <Alert
          severity="warning"
          onClose={() => setShowBanner(false)}
          sx={{
            position: "fixed",
            top: { xs: "56px", sm: "64px" },
            width: "100%",
            zIndex: (t) => t.zIndex.snackbar,
            borderRadius: 0,
          }}
        >
          ⚠️ 94 703 427 899 is no longer Lemda’s official contact number. Any
          messages from that number are <strong>not</strong> from us—please
          ignore them.
        </Alert>
      </Collapse>

      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/career" element={<CareersPage />} />
          <Route path="/webgen" element={<WebsiteGeneratorPage />} />
          <Route path="/photoedit" element={<PhotoEditorPage />} />
          <Route path="/robot" element={<RobotPlayground />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />
          {/* <Route path="/drop" element={<AIToolsPage />} /> */}
          <Route path="/drop" element={<DropshipToolsPage />} />
        </Routes>
        <Footer/>
        <ChatAssistant />
      </Router>
    </ThemeProvider>
  );
}

export default App;
